"use client";

import { Input } from "@/components/ui/input";
import { useRouter } from "@/i18n/navigation";
import { Search } from "lucide-react";
import { useSearchParams } from "next/navigation";
import { Suspense, useState } from "react";

type PropsType = {
  placeholderText: string;
};

export function BlogSearchSkeleton() {
  return (
    <div className="relative w-full max-w-[478px] animate-pulse">
      <div className="h-10 w-full rounded-[1.4375rem] bg-muted shadow" />
      <div className="absolute end-3 top-1/2 h-5 w-5 -translate-y-1/2 rounded-full bg-muted-foreground/20" />
    </div>
  );
}

function BlogSearchContent({ placeholderText }: PropsType) {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [query, setQuery] = useState(searchParams.get("search") || "");

  const handleSearch = () => {
    const params = new URLSearchParams(window.location.search);

    if (query.trim()) {
      params.set("search", query.trim());
      params.delete("page");
    } else {
      params.delete("search");
    }

    router.push(`?${params.toString()}`, { scroll: false });
  };

  return (
    <div className="relative w-full max-w-[478px]">
      <Input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholderText}
        aria-label={placeholderText}
        className="w-full rounded-[1.4375rem] bg-background text-muted-foreground shadow focus-within:shadow-xl"
        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
      />
      <button
        type="button"
        aria-label="Search"
        className="absolute end-3 top-1/2 -translate-y-1/2 transform cursor-pointer text-primary"
        onClick={handleSearch}
      >
        <Search aria-hidden="true" />
      </button>
    </div>
  );
}

function BlogSearch({ placeholderText }: PropsType) {
  return (
    <Suspense fallback={<BlogSearchSkeleton />}>
      <BlogSearchContent placeholderText={placeholderText} />
    </Suspense>
  );
}

export default BlogSearch;
